import * as services from '@api';
import { requiredValidate } from '../utils';
import { isType } from '@src/utils';
import { detailPaging } from './detail'
import ErrDisplay from '../../stores/cardstore/ErrDisplay'
import { PageStatusType } from '@stores/pagestore';
import { getLoadedPages } from '../../reactions/voucher/ListOfCardReaction'

export async function saveSubItem(rootStore: any, options: any = {}) {
  // 1. 如果是form删除所有子表 
  // 2. 如果是子表:包含孙表数据避免数据丢失
  // 3. 通用功能：校验、钩子
  requiredValidate.call(this, options, ['cardStoreKey', 'targetStoreKey'])
  const { cardStoreKey = 'cardStore', targetStoreKey, dataSourceAlias = '' } = options;
  const { utils = {}, pageStore = {} } = rootStore;
  const { params = {}, query = {} } = pageStore;
  const cardStore = rootStore.get(cardStoreKey);
  const targetStore = rootStore.get(targetStoreKey);
  try {
    let data: any = {}, pass = true, validateRes: any = { tables: [] }, targetItem: any = {}
    if (targetStoreKey === cardStore.formStore) {
      data = targetStore.getValue()
      const formValidateRes = rootStore[targetStoreKey].validate()
      if (formValidateRes.hasErr) {
        validateRes.form = formValidateRes
        pass = false
      }
    } else {
      const { item, levels } = findDataSourceByAlias(cardStore.tableStores, targetStoreKey)
      targetItem = item
      const cardStoreValue = cardStore.getValue()
      if (levels?.length > 0) {
        const key = levels[0]
        data[key] = cardStoreValue?.[key] 
      }
      data.id = cardStoreValue?.['id']

      const sValidateRes = rootStore[targetStoreKey].validate()
      const sInvalid = sValidateRes.filter((res: any, rowIndex: number) => { res.rowIndex = rowIndex; return res?.hasErr })
      if (sInvalid.length) {
        pass = false
        validateRes.tables.push({
          caption: targetStore.caption,
          errors: sInvalid
        })
      }
    }
      pageStore?.startLoading?.();
      // 校验
      const innerValidate = () => {
        !pass && rootStore.utils.message.danger({
          content: <ErrDisplay terminalType={rootStore.pageStore?.params?.terminalType} errors={validateRes} />
        })
        !pass && this.abort({ log: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B8002D', '表单校验失败，请检查') })
      }
      if (isType(this.validateHook, 'Function')) {
        data = await this.validateHook(rootStore, data, { innerValidate });
      } else {
        innerValidate();
      }
      // 请求
      const mode = cardStore.uiState || pageStore.status;
      let saveData = {
        params: {
          ...query,
          datasource: dataSourceAlias || cardStore?.dataSource || '',
          billnum: options.billNo || params.billNo,
          billId: options.billId || params.billId,
          busiObj: options.busiObj || query.busiObj,
          mode
        },
        data: { data }
      };
      // beforeSaveHook
      if (isType(this.beforeSaveSubItemHook, 'Function')) {
        saveData = await this.beforeSaveHook(rootStore, saveData);
      }
      // 发送请求
      let saveRes = await services.save(saveData);
      // afterSaveHook
      if (isType(this.afterSaveSubItemHook, 'Function')) {
        saveRes = await this.afterSaveHook(rootStore, saveRes);
      }
      await detailPaging.call(this, rootStore, { cardStoreKey });
      // 数据回写
    cardStore.setValue(saveRes.data, { merge: true });
    const loadInfo = getLoadedPages(cardStore, targetItem)
    loadInfo?.forEach((element:any) => {
      element.reload = true
    });
    
      // await loadListData(rootStore, {cardStore: cardStoreKey}, targetItem, false, 1)
      traverse(rootStore, [targetItem])
      // targetStore.setUiState(PageStatusType.BROWSE);
      utils.message.success(lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B8002E', '保存成功', undefined, { returnStr: true }));
      return saveRes;
  } catch (err: any) {
    utils.message.danger(err?.message);
    return Promise.reject(err);
  } finally {
    pageStore?.endLoading?.();
  }
}

/**
 * 在cardStore中关系中查询节点及children信息
 * @param data 
 * @param alias 
 * @param currentPath 
 * @returns 
 */
function findDataSourceByAlias(data: any, alias: string, currentPath = []): any {
  for (const item of data) {
    if (item.alias === alias) {
      return {
        children: item.children,
        levels: [...currentPath, item.dataSource],
        item: item };
    } else if (item.children) {
      // @ts-ignore
      const result = findDataSourceByAlias(item.children, alias, [...currentPath, item.dataSource]);
      if (result) { return result }
    }
  }
  return {};
}

function traverse(rootStore: any, data: any) {
  for (let i = 0; i < data.length; i++) {
    const item = data[i];
    if (item.alias) {
      rootStore[item.alias].setUiState(PageStatusType.BROWSE);
    }
    if (Array.isArray(item.children)) {
      traverse(rootStore, item.children);
    }
  }
}